import { TApplicationState } from '../../types/redux';

export const selectModelVersion = (state: TApplicationState) => {
  return state.newbuildingRecommendations.modelVersion;
};
